import { MusicIcon } from './MusicIcon';

export function PodiumMedal({ rank }: { rank: number }) {
  if (rank > 3) return <span>{rank}</span>;
  return <span className="bt-podium-medal" aria-label={`${rank}${rank === 1 ? 're' : 'e'} place`}><MusicIcon name="award" size="2em"/><b>{rank}</b></span>;
}
